import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import GlobalPopUps from 'components/Common/GlobalPopUps';
import DocumentTitle from 'utils/DocumentTitle';

import Landing from './Landing';
import Account from './Account';
import InfoMaterials from './InfoMaterials';
import SpecPages from './SpecPages';
import Help from './Help';
import Confirm from '../../Common/Confirm';

const routes = [
  {
    path: '/',
    exact: true,
    component: Landing
  },
  {
    path: '/spec',
    component: SpecPages,
    pageTitle: 'Информационный раздел'
  },
  {
    path: '/account',
    component: Account
  },
  {
    path: '/help',
    component: Help,
    pageTitle: 'Помощь'
  },
  {
    path: '/info/:tagUrl',
    component: InfoMaterials,
    pageTitle: 'Информационный раздел'
  },
  {
    path: '/confirm',
    component: Confirm
  },
  {
    path: '*',
    component: () => <Redirect to="/account/sign" />
  }
];

const RouteWithSubRoutes = route => (
  <Route
    path={route.path}
    exact={route.exact || false}
    render={props => {
      // pass the sub-routes down to keep nesting
      if (route.pageTitle) {
        return (
          <DocumentTitle title={route.pageTitle}>
            <route.component {...props} routes={route.routes} />
          </DocumentTitle>
        );
      }
      return <route.component {...props} routes={route.routes} />;
    }}
  />
);

// eslint-disable-next-line react/prefer-stateless-function
class Content extends Component {
  render() {
    return (
      <React.Fragment>
        <GlobalPopUps />
        <Switch>
          {routes.map(route => (
            <RouteWithSubRoutes key={`route${route.path}`} {...route} />
          ))}
        </Switch>
      </React.Fragment>
    );
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/Content.js